import React, { Component, lazy, Suspense } from "react";
import { Route, Switch, BrowserRouter as Router, Redirect } from "react-router-dom";
// import ReactPixel from 'react-facebook-pixel'
import i18n from '@/i18n'
import qs from 'query-string'

import Loading from '@/_mobile/Loading/Loading';
import Header from "@/_mobileCustomPages/Video09/Common/Header";
import * as ChannelIO from '@/utils/ChannelIO'
import DataManager from "@/utils/DataManager";
const MobileHome = lazy(() => import("@/_mobileCustomPages/Video09/Home"));
const MobileOrder = lazy(() => import("@/_mobileCustomPages/Video09/Routers/MobileOrder"));
const MobilePayment = lazy(() => import("@/_mobileCustomPages/Video09/Routers/MobilePayments"));


class Video09MobileRouter extends Component {
    componentDidMount = () => {
        let theme = "theme-light";
        const app = document.getElementsByClassName("app");
        if (app) app[0].style.overflowX = "hidden";
        
        window.oncontextmenu = null;

        const vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)
        
        document.body.classList.add(theme);
        this.InitChannelIO();

        const link = document.getElementById("favicon")
        link.href = "https://front.videomonster.com/images-7cuytg20/web/video09/video09-favicon.svg"

        const query = qs.parse(window.location.search, { ignoreQueryPrefix: true })
        if (query.spot) sessionStorage.setItem("spot", query.spot);

        const { VIDEO09 } = DataManager.PROVIDER;
        if ((DataManager.IsProvider(VIDEO09) || query.provider === VIDEO09)) {
            if (query.cafe24) {
                const { bdom, mid, email, shopname } = query;
                const data = JSON.stringify({ bdom, mid, email, shopname });
                DataManager.CryptoStorage.SetSessionItem("vUserData", data)
            }
            if (Object.keys(query).length) window.history.replaceState(null, null, `${window.location.origin}${window.location.pathname}`);
        }
    }
    InitChannelIO = async () => {
        const { currentUser } = this.props

        await ChannelIO.Initialize();
        ChannelIO.Boot(currentUser);
    }
    render() {
        return (
            <Suspense fallback={
                <>
                    {
                        <header
                            style={{
                                height: 50,
                                width: '100vw',
                                borderBottom: 'border-bottom: 1px solid var(--color-box-border)',
                                zIndex: 100,
                                backgroundColor: 'var(--color-primary)'
                            }}
                        />
                    }
                    <div style={{ width: '100vw', height: 'calc(100vh - 120px)', color: 'var(--color-background)', paddingBottom: 120 }}>
                        <Loading componentName={i18n.t("mobile.loading")} />
                    </div>

                </>
            }>
                <Header history={this.props.history}/>
                <Switch>
                    <Route exact path={`/`} component={props => <MobileHome {...props} />} />
                    <Route path={`/order`} component={props => <MobileOrder {...props} />} />
                    <Route path={`/payment`} component={props => <MobilePayment {...props} />} />
                    <Route component={() => <Redirect to={'/'} />} />
                </Switch>
            </Suspense>
        );
    }
}

export default Video09MobileRouter